

const CartDrawerUtils = {
  
  elements: {
    cartDrawerBackground: null,
    cartDrawer: null,
    cartDrawerClose: null
  },

  
  init() {
    this.elements.cartDrawerBackground = document.querySelector('.cart-drawer-background');
    this.elements.cartDrawer = document.querySelector('.cart-drawer');
    this.elements.cartDrawerClose = document.querySelector('.cart-drawer-close');
    
    this.attachEventListeners();
    return this;
  },

  
  attachEventListeners() {
    
    if (this.elements.cartDrawerBackground) {
      this.elements.cartDrawerBackground.addEventListener('click', (e) => {
        if (e.target === this.elements.cartDrawerBackground) {
          e.preventDefault();
          this.closeCartDrawer();
        }
      });
    }

    
    this.attachCloseButtonListener();
  },

  
  attachCloseButtonListener() {
    const closeButton = document.querySelector('.cart-drawer-close');
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeCartDrawer();
      });
    }
  },

  
  updateCartDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(response => response.json())
      .then(data => {
        const newHTML = data['cart-drawer'];
        const html_to_dom = new DOMParser();
        const newdoc = html_to_dom.parseFromString(newHTML, 'text/html');
        const newdrawer = newdoc.querySelector('.cart-drawer');
        
        if (this.elements.cartDrawer && newdrawer) {
          this.elements.cartDrawer.innerHTML = newdrawer.innerHTML;
          
          
          this.attachCloseButtonListener();
          
          
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
      });
  },

  
  openCartDrawer() {
    return this.updateCartDrawer().then(() => {
      if (this.elements.cartDrawerBackground) {
        this.elements.cartDrawerBackground.classList.add('is-visible');
      }
      document.body.style.overflow = 'hidden';
      if (this.elements.cartDrawer) {
        this.elements.cartDrawer.style.transform = 'translateX(0)';
      }
    });
  },

  
  closeCartDrawer() {
    if (this.elements.cartDrawerBackground) {
      this.elements.cartDrawerBackground.classList.remove('is-visible');
    }
    document.body.style.overflow = 'auto';
    if (this.elements.cartDrawer) {
      this.elements.cartDrawer.style.transform = 'translateX(100%)';
    }
  },

  
  addToCart(variantId, quantity = 1, giftInfo = {}) {
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity
      }]
    };
    
    
    if (giftInfo && Object.keys(giftInfo).length > 0) {
      formData.items[0].properties = {};
      
      if (giftInfo.phone) {
        formData.items[0].properties['Recipient Phone'] = giftInfo.phone;
      }
      
      if (giftInfo.name) {
        formData.items[0].properties['Recipient Name'] = giftInfo.name;
      }
    }
    
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      } else {
        this.openCartDrawer();
      }
      return data;
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      throw error;
    });
  },

  
  removeCartItem(itemKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(() => {
      return this.updateCartDrawer();
    })
    .catch(error => {
      console.error('Error removing item from cart:', error);
      throw error;
    });
  }
};


window.CartDrawerUtils = CartDrawerUtils; 